import {Component, OnChanges, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {BaseComponent} from '../../core/base.component';
import {AuthService} from '../../core/security/auth.service';
import {RolesEnum} from '../../core/security/roles.enum';
import {BasicSoftPhoneService} from '../basic-soft-phone.service';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {passwordValidator} from '../../core/validators/password.validator';
import {matchFields} from '../../core/validators/match-fields.validator';
import {NotificationService} from '../../notification/notification.service';
import {BasicSoftPhoneSummaryModel} from '../../api/models/basic-soft-phone-summary-model';
import {BasicSoftPhoneChangePasswordModel} from '../../api/models/basic-soft-phone-change-password-model';
import {LookupModel} from '../../api/models/lookup-model';
import {LookupService} from '../../api/services/lookup.service';
import {BasicSoftPhoneSaveSettingsModel} from '../../api/models/basic-soft-phone-save-settings-model';
import {ModulesEnum} from '../../core/security/modules.enum';
import {CurrentUser} from '../../api/models/current-user';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgIf } from '@angular/common';
import { MatSimpleSelectComponent } from '../../editors/mat-simple-select/mat-simple-select.component';
import { MatButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { YesNoPipe } from '../../core/pipes/yesno.pipe';
import { ShowHideComponent } from '../../core/visual/show-hide/show-hide.component';

@Component({
    selector: 'app-softphone-summary',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatCard,
        MatCardTitle,
        MatCardContent,
        NgIf,
        MatSimpleSelectComponent,
        MatCardActions,
        MatButton,
        MatTooltip,
        Angular2PromiseButtonModule,
        YesNoPipe,
        ShowHideComponent
    ],
})
export class SummaryComponent extends BaseComponent implements OnInit, OnDestroy, OnChanges {

  detailsUrl: string;
  buttonSubmitPromise: Promise<void>;
  buttonSettingsSubmitPromise: Promise<void>;
  isLoading = false;
  hasError = false;
  hasProMessagingModule = false;
  submitted = false;
  changePasswordForm: FormGroup<{ newPassword: FormControl, confirmPassword: FormControl }>;
  summaryModel: BasicSoftPhoneSummaryModel = {};
  smsPhoneNumbers: LookupModel[] = [];
  form: FormGroup<{ smsNumberId: FormControl }>;

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title,
              public authService: AuthService,
              public softPhoneService: BasicSoftPhoneService,
              private notificationService: NotificationService,
              private lookupService: LookupService
  ) {
    super(route, headerService, titleService, authService);

    this.editRoles = [RolesEnum.BasicSoftPhoneEdit, RolesEnum.BasicSoftPhoneDelete];
    this.deleteRoles = [RolesEnum.BasicSoftPhoneDelete];



    this.createForms();
  }

  onCurrentUserChanged(user?: CurrentUser) {
    super.onCurrentUserChanged(user);
    this.hasProMessagingModule = this.authService.userHasPackage(ModulesEnum.ProMessagingModule);
  }

  async ngOnInit() {
    this.getSummary().then(() => {
      console.log('After getSummary');
    });

    console.log('on init');
    await super.ngOnInit();
  }

  async getSummary(): Promise<void> {
    this.summaryModel = await this.softPhoneService.getSoftphoneSummary();

    this.smsPhoneNumbers = await this.getSmsNumbersLookup();

    this.form.reset({
      // extension: this.summaryModel.extension,
      smsNumberId: this.summaryModel.smsNumberId
    });
  }

  async getSmsNumbersLookup() {
    const result = await this.lookupService.lookupGetSmsNumbers({
      extension: this.summaryModel.extension
    }).toPromise();

    result.data.splice(0, 0, {id: '', text: 'None'});

    return result.data;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  createForms(): void {
    this.form = new FormGroup({
      // extension: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
      smsNumberId: new FormControl('', {nonNullable: false}),
    });

    const fb = new FormBuilder();

    this.changePasswordForm = fb.group({
        newPassword: ['', [Validators.required, passwordValidator]],
        confirmPassword: ['', Validators.required]
      },
      {validators: matchFields('newPassword', 'confirmPassword')}
    );
  }

  ngOnChanges() {
    this.changePasswordForm.reset({});

  }

  async onSubmit() {

    this.hasError = false;

    if (this.changePasswordForm.valid) {
      this.buttonSubmitPromise = this.processSubmit();
    }
  }

  async processSubmit(): Promise<void> {
    try {
      const reqData = this.prepareFormModel();

      await this.softPhoneService.changeSoftPhonePassword(reqData)
      this.notificationService.notifySuccess('SoftPhone password successfully changed');
      await this.getSummary();
      this.ngOnChanges();
    } catch (e) {

    } finally {
      this.submitted = false;
    }
  }

  prepareFormModel(): BasicSoftPhoneChangePasswordModel {
    const formModel = this.changePasswordForm.value;

    return {
      password: formModel.newPassword as string
    };
  }

  onSettingsSubmit() {
    this.hasError = false;

    if (this.form.valid) {
      this.buttonSettingsSubmitPromise = this.processSettingsSubmit();
    }
  }

  async processSettingsSubmit(): Promise<void> {
    this.submitted = true;
    const reqData = this.prepareSettingsFormModel();

    try {
      if (await this.softPhoneService.saveSoftPhoneSettings(reqData)) {
        this.notificationService.notifySuccess('SoftPhone settings successfully updated');
        await this.getSummary();
        this.ngOnChanges();
      }
    } catch (e) {
      console.log(e);
      this.hasError = true;
    } finally {
      this.submitted = false;
    }
  }

  prepareSettingsFormModel(): BasicSoftPhoneSaveSettingsModel {
    const formModel = this.form.value;

    return {
      extension: this.summaryModel.extension, // formModel.extension,
      smsNumberId: formModel.smsNumberId
    };
  }
}
